import functions from "./functions";

let checkAllToggles;

function selectAllCheckbox() {

    checkAllToggles.forEach((input) => {
        checkAll.checked ? input.checked = true : input.checked = false;
    });
}

let checkAll;
let checkCount = 0;

function expandedOrderList() {
    const expandButtons = document.querySelectorAll('[data-expand-toggle]');

    expandButtons.forEach(e => {
        e.addEventListener('click', () => {
            e.previousElementSibling.classList.toggle('show');
            if (e.previousElementSibling.classList.contains('show')) {
                e.classList.add('active');
            } else {
                e.classList.remove('active');
            }
        });
    });
}

function init() {

    if (functions.checkPage('my-account')) {
        checkAll = document.querySelector('[data-account-checkbox-all]');
        checkAllToggles = document.querySelectorAll('[data-account-checkbox-toggle]');

        if (checkAll && checkAllToggles) {
            checkAllToggles.forEach((input) => {
                input.checked ? checkCount++ : null;
                checkCount === checkAllToggles.length ? checkAll.checked = true : null;
            });
            checkAll.addEventListener('change', selectAllCheckbox);
        }

        expandedOrderList();
    }

    if (functions.checkPage('my-account')) {

        if (window.innerWidth <= functions.breakpoints.sm) {

            $('.my-account__nav').addClass('mobile visible');

            $('[data-navigation-output]').addClass('hidden');

            $('[data-navigation-backward]').addClass('hidden').on('click', function () {
                $('[data-navigation-output]').addClass('hidden');
                $('.my-account__nav').toggleClass('visible');
                $(this).addClass('hidden');
            });

            $('.my-account__nav ul li a').each(function (index, item) {
                const currentURL = window.location.href;
                if (currentURL === $(item).attr('href') ||
                    currentURL.indexOf($(item).attr('href') === 0)) {
                    $('.my-account__nav').removeClass('visible');
                    $('[data-navigation-output]').removeClass('hidden');
                    $('[data-navigation-backward]').removeClass('hidden');
                }
            });

            $('.my-account__nav.mobile li a').on('click', function (e) {
                if ($(this).parent().hasClass('is-active')) {
                    e.preventDefault();

                    $('.my-account__nav').removeClass('visible');
                    $('[data-navigation-output]').removeClass('hidden');
                    $('[data-navigation-backward]').removeClass('hidden');
                }
            });
        }
    }
}

export default {init};
